export enum TipoCancelamentoEnum {
    disponivel = "Disponivel",
    Indisponivel = "Indisponivel",
    Desistencia = "Desistencia",
    Trocado = "Trocado"
}